module.exports = __webpack_public_path__ + "img/rain-light.f8065075.png";